import Vue from "vue";
import Router from "vue-router";

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");

// Views
const Dashboard = () => import("@/views/Dashboard");
const AuthCallback = () => import("@/views/components/AuthCallback");

// Views - Companies
const Companies = () => import("@/views/administration/Companies");
const Users = () => import("@/views/administration/Users");
const BenefitVehicles = () => import("@/views/administration/BenefitVehicles");
const BenefitVehicle = () => import("@/views/administration/BenefitVehicle");
const Company = () => import("@/views/administration/Company");
const User = () => import("@/views/administration/User");
const Import = () => import("@/views/administration/Import");


const ProcessedExpenses = () => import("@/views/expenses/ProcessedExpenses");
const CongestionTaxExpenses = () =>
  import("@/views/expenses/CongestionTaxExpenses");
const CongestionTaxPassages = () =>
  import("@/views/expenses/CongestionTaxPassages");

const SalarySpecifications = () =>
  import("@/views/salaryspecifications/Salaryspecifications");
const SalarySpecification = () =>
  import("@/views/salaryspecifications/Salaryspecification");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");
const Register = () => import("@/views/pages/Register");

Vue.use(Router);

const router = new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/auth_callback",
      name: "AuthCallback",
      component: AuthCallback
    },
    {
      path: "/",
      redirect: "/dashboard",
      name: "Hem",
      component: DefaultContainer,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard
        },
        {
          path: "/expenses",
          name: "Utgifter",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "processed",
              meta: { label: "Bearbetade utgifter" },
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "",
                  component: ProcessedExpenses
                }
              ]
            },
            {
              path: "congestiontax",
              meta: { label: "Trängselskatt" },
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "",
                  component: CongestionTaxExpenses
                },
                {
                  path: ":id",
                  meta: { label: "Hantera period " },
                  name: "CongestionTaxPassages",
                  component: CongestionTaxPassages
                }
              ]
            }
          ]
        },
        {
          path: "/administration",
          name: "Administration",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "companies",
              meta: { label: "Företag" },
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "",
                  component: Companies
                },
                {
                  path: ":id",
                  meta: { label: "Företagsinformation " },
                  name: "CompanyInformation",
                  component: Company
                }
              ]
            },
            {
              path: "users",
              meta: { label: "Användare" },
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "",
                  component: Users
                },
                {
                  path: ":id",
                  meta: { label: "Användarinformation " },
                  name: "UserInformation",
                  component: User
                }
              ]
            },
            {
              path: "benefitvehicles",
              meta: { label: "Fordon" },
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "",
                  component: BenefitVehicles
                },
                {
                  path: ":id",
                  meta: { label: "Fordonsinformation " },
                  name: "BenefitVehicleInformation",
                  component: BenefitVehicle
                }
              ]
            },
            {
              path: "import",
              meta: { label: "Import" },
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "",
                  component: Import
                }
              ]
            },
          ]
        },
        {
          path: "/salaryspecifications",
          name: "Lönespecifikationer",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: SalarySpecifications
            },
            {
              path: ":id",
              meta: { label: "Lönespecifikation " },
              name: "Lönespecifikation",
              component: SalarySpecification
            }
          ]
        }
      ]
    },

    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404
        },
        {
          path: "500",
          name: "Page500",
          component: Page500
        },
        {
          path: "login",
          name: "Login",
          component: Login
        },
        {
          path: "register",
          name: "Register",
          component: Register
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/pages/login", "/auth_callback/"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("user");

  if (authRequired && !loggedIn) {
    return next("/pages/login");
  }

  next();
});

export default router;
